module.exports = __webpack_public_path__ + "static/img/tom.6cc5c045.png";